import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import type { PageContextPayload } from '@contexts/pageContext'
import PageContext from '@contexts/pageContext'

import CreateOrEditAgencyProviderModal from '@modals/CreateOrEditAgencyProviderModal'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditAgencyProviderModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: string, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditAgencyProviderModal: {
      closeModal: () => setState({ showCreateOrEditAgencyProviderModal: false }),
      createAgencyProvider: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditAgencyProviderModal,
  } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrEditAgencyProviderModal: (payload: HandleCallbackActionParams) => {
        setModalData('CreateOrEditAgencyProviderModal', payload)
        setState({ showCreateOrEditAgencyProviderModal: true })
      },
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrEditAgencyProviderModal
          callbacks={callbacks('CreateOrEditAgencyProviderModal', setState)}
          showModal={showCreateOrEditAgencyProviderModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
